export default function ({ ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M7.99954 1.86719C9.69306 1.86719 11.2264 2.55378 12.3363 3.66373C13.4463 4.77368 14.1329 6.30701 14.1329 8.00052C14.1329 9.69403 13.4463 11.2274 12.3363 12.3373C11.2264 13.4473 9.69306 14.1339 7.99954 14.1339C6.30603 14.1339 4.77271 13.4473 3.66275 12.3373C2.5528 11.2274 1.86621 9.69403 1.86621 8.00052C1.86621 6.30701 2.5528 4.77368 3.66275 3.66373C4.77271 2.55378 6.30603 1.86719 7.99954 1.86719Z"
                stroke="#010101"
            />
            <path
                d="M7.14258 4.85714C7.14258 5.33053 7.52633 5.71429 7.99972 5.71429C8.47311 5.71429 8.85686 5.33053 8.85686 4.85714C8.85686 4.38376 8.47311 4 7.99972 4C7.52633 4 7.14258 4.38376 7.14258 4.85714Z"
                fill="#010101"
            />
            <path
                d="M8.66634 7.33268C8.66634 6.96449 8.36786 6.66602 7.99967 6.66602C7.63148 6.66602 7.33301 6.96449 7.33301 7.33268V10.666C7.33301 11.0342 7.63148 11.3327 7.99967 11.3327C8.36786 11.3327 8.66634 11.0342 8.66634 10.666V7.33268Z"
                fill="#010101"
            />
        </svg>
    );
}
